import React from 'react';

export interface VViewerIFrameProps extends React.ComponentProps<'iframe'> {
  glbUrl: string;
}

export const VViewerIFrame: React.FC<VViewerIFrameProps> = ({
  glbUrl,
  ...props
}) => (
  <iframe
    src={`https://viewer.pfn3d.com/static-viewer/embed.html#?${new URLSearchParams(
      {
        glb: glbUrl,
        autostart: '1',
        ar: '0',
      }
    )}`}
    {...props}
  />
);
